import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Receipt } from 'lucide-react';

/**
 * Local /api/billing/transactions paid history.
 * Separate from Stripe invoices — this is the app's own record.
 */
export default function PaymentHistory({ transactions }) {
  const paid = transactions.filter(tx => tx.payment_status === 'paid');
  if (paid.length === 0) return null;
  return (
    <Card data-testid="transactions-card">
      <CardHeader className="pb-3">
        <div className="flex items-center gap-2">
          <Receipt className="w-5 h-5 text-gray-500" />
          <CardTitle className="text-lg">Payment History</CardTitle>
        </div>
      </CardHeader>
      <CardContent>
        <div className="divide-y">
          {paid.map((tx) => (
            <div key={tx.transaction_id} className="flex items-center justify-between py-3" data-testid={`tx-${tx.transaction_id}`}>
              <div>
                <p className="text-sm font-medium text-gray-800">
                  {tx.plan === 'provider' ? 'Provider' : 'Solo'} Plan
                  {tx.addons?.extra_orgs > 0 ? ` + ${tx.addons.extra_orgs} orgs` : ''}
                  {tx.addons?.extra_companies > 0 ? ` + ${tx.addons.extra_companies} companies` : ''}
                </p>
                <p className="text-xs text-gray-500">
                  {new Date(tx.created_at).toLocaleDateString()}
                  {tx.billing_mode === 'subscription' && <span className="ml-1.5 text-teal-600">(recurring)</span>}
                </p>
              </div>
              <div className="text-right">
                <p className="text-sm font-semibold">${tx.amount?.toFixed(2)}/mo</p>
                <span className={`text-xs px-1.5 py-0.5 rounded ${
                  tx.payment_status === 'paid' ? 'bg-green-100 text-green-700' :
                  tx.status === 'initiated' ? 'bg-yellow-100 text-yellow-700' :
                  'bg-gray-100 text-gray-600'
                }`}>
                  {tx.payment_status === 'paid' ? 'Paid' : tx.status === 'initiated' ? 'Pending' : tx.status}
                </span>
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
